
export const Api_Caller = {
  auth: "auth/login",
  summary: "dashboard/summary",
  attendance: "dashboard/attendance",
  attendanceDetails: "dashboard/attendance",
  visits: "dashboard/recent-visits",
  changePassword: "auth/change-password",
  agents: "agent/agents",
  createAgent: "agent/create-agent",
  tracking: "dashboard/tracking",
  getVisitsBySession: "visits/session",
  agentStatus:"auth/change-status",
  changeSelfieStatus: "auth/change-selfie-status",
  changeSelfieStatusAll: "auth/change-selfie-status-all",
  getSelfies: "dashboard/tracking",
  getFarmer: "visits/farmers",
  getFarmerDetails: "visits/farmers"
};


